import React, { FC, useEffect } from "react";
import * as NavigationActions from '../../../actions/navigation';
import RestrictedLayout from "../../../components/layouts/RestrictedLayout";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { QaSettingsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { SettingsQASubMenu, SettingsSubMenu } from "../../../helpers/subMenuHelper";
import useDispatch, { useActionCreator } from "../../../hooks/useDispatch";
import useSelector from "../../../hooks/useSelector";
import SettingsCard from "../SettingsCard";

import './QaSettingsPage.scss';

const QaSettings: FC = () => {
    // Sidebar items
    const permissions = useSelector(state => state.user.userSummary?.permissions ?? []);
    const sideBarItems = SettingsSubMenu(permissions);
    
    // Breadcrumbs
    const breadcrumbs = QaSettingsBreadcrumbs();

    // Menu items
    const menuItems = SettingsQASubMenu(permissions);

    const dispatch = useDispatch();
    const setDrawerItems = useActionCreator(NavigationActions.SetDrawerItems, dispatch);
    const setBreadcrumbs = useActionCreator(NavigationActions.SetBreadcrumbs, dispatch);

    useEffect(() => {
        setDrawerItems(sideBarItems);
        setBreadcrumbs(breadcrumbs);
    }, [setDrawerItems, setBreadcrumbs]);

    const renderQaSettingsCards = () => {
        return menuItems?.filter(x => x.description)?.map((item, index) => (
            <SettingsCard 
                key={`item-${item.title}-${index}`}
                navItem={item}
            />
        ));
    }

    return (
        <RestrictedLayout
            permission={Dtos.Permission.ProjectSettingsView}
        >
            <div className="settings-page">
                <div className="settings-container">
                    <h1 className="mb-4">QA</h1>
                    <div className="settings-grid">
                        {renderQaSettingsCards()}
                    </div>
                </div>
            </div>
        </RestrictedLayout>
    );
}

export default QaSettings;